import { defineStore, acceptHMRUpdate } from 'pinia'
import type { Locale } from '#shared/types/users.ts'
import { usePersist } from '~/plugins/pinia.ts'

interface State {
  locale: Locale
  hasInitializedLocale: boolean
}

export const useLocaleStore = defineStore('locale', {
  state: (): State => ({
    locale: 'nl',
    hasInitializedLocale: false
  }),
  persist: usePersist<State>({
    storage: piniaPluginPersistedstate.cookies()
  }),
  logout: true,
  actions: {},
  getters: {
    localeIsDutch: (state: State): boolean => state.locale === 'nl'
  }
})

/**
 * Pinia supports Hot Module replacement, so you can edit your stores and
 * interact with them directly in your app without reloading the page.
 *
 * @see https://pinia.esm.dev/cookbook/hot-module-replacement.html
 * @see https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useLocaleStore, import.meta.hot))
}
